import LoadingButton from "@mui/lab/LoadingButton";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Hidden from "@mui/material/Hidden";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useLoginMutation } from "api/auth/auth.mutation";
import lockIcon from "assets/login/lock.svg";
import userNameIcon from "assets/login/user_profile.svg";
import { handleError } from "functions/apiHandleError";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router-dom";
import useStore from "store";
import IustPic from "../iustPic/IustPic";
import classes from "./styles/Login.module.scss";

const Login = () => {
  const { accessTokenStore, storeLogin } = useStore();
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();
  const history = useNavigate();

  const loginMutation = useLoginMutation();

  const handleFormSubmit = async (data) => {
    try {
      const response = await loginMutation.mutateAsync({ ...data });
      const { auth_token, ...userInfo } = response;
      storeLogin(auth_token, userInfo);
      history("/dashboard");
    } catch (err) {
      handleError({ err, setError });
    }
  };

  useEffect(() => {
    if (accessTokenStore) {
      history("/dashboard");
    }
  }, []);

  return (
    <>
      <Container className={classes.signUpContainer}>
        <Grid container className={classes.signUpBox}>
          <Hidden mdDown>
            <Grid item md={5} lg={6} sx={{ height: "100%" }}>
              <IustPic />
            </Grid>
            <Grid item xs={1} />
          </Hidden>
          <Grid item xs={12} md={6} lg={5} className={classes.loginForm}>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
              <Box className={classes.loginBox}>
                <Typography marginBottom={"0.4rem"}>Login</Typography>

                <TextField
                  fullWidth
                  variant="outlined"
                  type="email"
                  sx={{
                    marginBottom: "1.5rem",
                    borderColor: "var(--google-button-border)",
                  }}
                  label={
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <LazyLoadImage
                        src={userNameIcon}
                        style={{
                          paddingRight: "0.3rem",
                          width: "1.1rem",
                        }}
                      />
                      <span>email</span>
                    </div>
                  }
                  {...register("email", { required: true })}
                  error={errors?.email}
                  helperText={errors?.email?.message}
                />

                <div className={classes.buttons}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    type="password"
                    label={
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <LazyLoadImage
                          src={lockIcon}
                          style={{
                            paddingRight: "0.3rem",
                            width: "1.1rem",
                          }}
                        />
                        <span>password</span>
                      </div>
                    }
                    {...register("password", {
                      required: "this field is required",
                    })}
                    error={errors?.password}
                    helperText={errors?.password?.message}
                  />
                </div>

                <LoadingButton
                  loading={loginMutation.isPending}
                  loadingPosition="start"
                  fullWidth
                  type="submit"
                  className={`${classes.loginBtn} ${
                    loginMutation.isPending && classes.disabledBtn
                  }`}
                >
                  Login
                </LoadingButton>
              </Box>
            </form>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Login;
